export default "__VITE_ASSET__Dh1QY8YH__"